import { render, staticRenderFns } from "./YoutubeSummary.vue?vue&type=template&id=3660cb36&scoped=true&"
import script from "./YoutubeSummary.vue?vue&type=script&lang=js&"
export * from "./YoutubeSummary.vue?vue&type=script&lang=js&"
import style0 from "./YoutubeSummary.vue?vue&type=style&index=0&id=3660cb36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3660cb36",
  null
  
)

export default component.exports